module.exports = __webpack_public_path__ + "static/gallery15-97176b6f6b0fb64c3fb5dca833828e9b.jpg";